import React, { useState, useCallback, useEffect } from 'react';
import { EnhancedInputField } from './EnhancedInputField';
import axios from 'axios';
import { API } from '../../shared/api/Api';
import { useSelector } from 'react-redux';
import { selectInstructorData } from '../../features/instructors/instructorSlice';
import { selectUserInformations } from '../../features/authSlice';
import { showToast } from '../../utils/utils';

const EnhancedInstructorItems = ({ field, formData, type, handleChange, disabled = false }) => {
    const instructor = useSelector(selectInstructorData);
    const user = useSelector(selectUserInformations);
    const [allInstructors, setAllInstructors] = useState(instructor?.items || []);
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);

    // Load more instructors with pagination
    const loadMoreInstructors = useCallback(async () => {
        if (loading || !hasMore) return;

        setLoading(true);
        try {
            const { data } = await axios.get(API.Instructors.app_instructors_all, {
                params: {
                    page: currentPage + 1,
                    limit: 20,
                },
                headers: { Authorization: `Bearer ${user.token}` },
            });

            if (data.status === 200 && data.errorCode === 0) {
                const newItems = data.data.items || [];
                setAllInstructors((prev) => [...prev, ...newItems]);
                setCurrentPage((prev) => prev + 1);
                setHasMore(data.data.current_page < data.data.last_page);
            }
        } catch (error) {
            showToast("Error", "Failed to load more instructors", "error");
        } finally {
            setLoading(false);
        }
    }, [currentPage, hasMore, loading, user.token]);

    // Initialize with Redux data if available
    useEffect(() => {
        if (instructor?.items && allInstructors.length === 0) {
            setAllInstructors(instructor.items);
            setHasMore((instructor.total || 0) > instructor.items.length);
        }
    }, [instructor, allInstructors.length]);

    const options = allInstructors.map((item) => ({
        id: item.id,
        name: `${item.first_name} ${item.last_name}`,
        title: `${item.first_name} ${item.last_name}`,
    }));

    return (
        <EnhancedInputField
            key={field.name}
            label={field.label}
            name={field.name}
            type={field.type}
            placeholder={field.placeholder}
            value={formData[field.name]}
            handleChange={handleChange}
            options={options}
            disabled={disabled}
            onLoadMore={hasMore ? loadMoreInstructors : null}
            hasMore={hasMore}
            loading={loading}
        />
    );
};

export default EnhancedInstructorItems;
